import { httpClient } from "@/services";

export default {
	state: {
		reportsFilter: null,
		reportsList: null,
	},
	mutations: {
		updateReportList(state, payload) {
			const { reports, filter } = payload;
			state.reportsFilter = filter;
			state.reportsList = reports;
		},
	},
	actions: {
		async onReports({ commit, dispatch }, url) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(url);
				if ( data && !data.status ) {
					commit('updateReportList', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onReportFilter({ commit, dispatch }, args) {
			dispatch("actionPreloader", true);
			try {
				const { filter, url } = args;
				const { data } = await httpClient.post(`${ url }/list`, filter);

				if (data && !data.status) {
					commit('updateReportList', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onReportSend({ dispatch }, args) {
			dispatch("actionPreloader", true);
			try {
				const { email, id, url } = args;
				const { data } = await httpClient.post(`${ url }/send/${ id }`, { email });
				if (data && !data.message) {
					dispatch('setAlert', { type: "success", message: "Report sent successfully" });
				} else {
					dispatch('setAlert', { type: "error", message: "Sending error" });
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
	},
	getters: {
		reportsFilter: s => s.reportsFilter,
		reportsList: s => s.reportsList,
	}
};
